module.exports = __webpack_public_path__ + "static/media/lingdaoli9.49180659.png";